import React from 'react';

const AJAX_Response = () => {
  return (
    <div >
      <h1>AJAX_Response</h1>
      <p>Placeholder component for: "AJAX Response"</p>
    </div>
  );
};

export default AJAX_Response;
